module.exports = __webpack_public_path__ + "onganize.jpg?7c30b80c98531b9e3452a6ef017ac8cd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/onganize.jpg
// module id = 141
// module chunks = 0